<div style="margin:50px;">
  <nz-date-picker nzFormat="dd/MM/yyyy HH:mm"  [nzShowTime]="{ nzFormat: 'HH:mm' }"></nz-date-picker>
</div>